export default [
    {
        header: 'Who is Matt',
        text: `Matt is a senior software developer.

        Matt has ${
            new Date(Date.now() - new Date(2011, 6, 1).getTime()).getFullYear() - 1970
        } years of software programming experience.

        Matt has extensive knowledge of backend systems and working with cloud architecture.`,
    },
    {
        header: 'What has Matt done',
        text: `Matt is currently working on many side projects.

        Matt likes to experiment with different frameworks to gain a better understanding of the current tools in the industry.
        
        Matt is also currently working on this website! Updates and additional features may be in store in the future.`,
    },
    {
        header: 'Where can Matt be found',
        text: `Currently Matt can be found on <a href="https://github.com/matthewswar">GitHub</a> and <a href="https://www.linkedin.com/in/matthew-swartzendruber-5a982175/">LinkedIn</a>.`,
    },
];
